/**
 * This object is used to map data types to field types
 * Refer enum DataType and enum ModelTypeFieldType in the proto file
 */
export const dataTypeToFieldTypeMap = {
  // STR = STRING
  1: 2,
  // BYTES = STRING
  2: 2,
  // INT = NUMBER
  3: 3,
  // FLOAT = NUMBER
  4: 3,
  // BOOL = BOOLEAN
  5: 1,
  // JSON_DATA = JSON
  7: 10,
  // TEXT = STRING
  8: 2,
  // IMAGE = STRING
  9: 2,
  // audio = STRING
  13: 2,
  // video = STRING
  14: 2,
  // NAMED_FIELDS = JSON
  15: 10,
  // TUPLE = JSON
  16: 10,
  // LIST = JSON
  17: 10,
} as Record<number, number>;
